var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Breakdown from './Breakdown';
import Explanation from './Explanation';
import { TypicaHandlingRateByBagCountTypes, TypicaHandlingRateByWeightTypes, } from '../../../constants/offerListValues';
var CenteredHeading = styled(Typography).attrs({ align: 'center' })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    font-weight: bold;\n    margin-bottom: 2em;\n  }\n"], ["\n  && {\n    font-weight: bold;\n    margin-bottom: 2em;\n  }\n"])));
var MainHeading = styled(CenteredHeading).attrs({ variant: 'h1' })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    font-size: 28px;\n    text-decoration: underline;\n  }\n"], ["\n  && {\n    font-size: 28px;\n    text-decoration: underline;\n  }\n"])));
var LotTitle = styled(CenteredHeading).attrs({ variant: 'h3' })(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var ExplanationRegion = styled(Explanation)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 2em;\n"], ["\n  margin-top: 2em;\n"])));
var TransparencyInformation = function (_a) {
    var vatReverseChargeEnabled = _a.vatReverseChargeEnabled, orderPriceItem = _a.orderPriceItem;
    var i18n = useTranslation().i18n;
    var offer = React.useMemo(function () { return orderPriceItem.orderItem.offer; }, [orderPriceItem.orderItem.offer]);
    var producerName = React.useMemo(function () {
        var producer = offer.offerList.producer;
        return "".concat(producer.firstname, " ").concat(producer.lastname);
    }, [offer.offerList]);
    var breakdown = React.useMemo(function () {
        var breakdownStrings = orderPriceItem.breakdownPer1kg;
        return {
            farm: parseFloat(breakdownStrings.farm),
            mill: parseFloat(breakdownStrings.mill),
            producer: parseFloat(breakdownStrings.producer),
            shippingFee: parseFloat(breakdownStrings.shippingFee),
            importTax: parseFloat(breakdownStrings.importTax),
            consumptionTax: parseFloat(breakdownStrings.consumptionTax),
            typica: parseFloat(breakdownStrings.typica),
            auctionBonus: parseFloat(breakdownStrings.auctionBonus),
            specialTypicaDiscount: parseFloat(breakdownStrings.specialTypicaDiscount),
        };
    }, [orderPriceItem.breakdownPer1kg]);
    var typicaHandlingRates = React.useMemo(function () {
        if (Object.keys(offer.offerList.typicaHandlingRates).includes('less_than_5_bags')) {
            return TypicaHandlingRateByBagCountTypes.reduce(function (result, key) {
                var offerTypicaHandlingRates = offer.typicaHandlingRates;
                var offerListTypicaHandlingRates = offer.offerList
                    .typicaHandlingRates;
                result[key] =
                    offerTypicaHandlingRates[key] || offerListTypicaHandlingRates[key];
                return result;
            }, {
                less_than_5_bags: '',
                more_than_5_bags: '',
                more_than_10_bags: '',
                more_than_50_bags: '',
            });
        }
        return TypicaHandlingRateByWeightTypes.reduce(function (result, key) {
            var offerTypicaHandlingRates = offer.typicaHandlingRates;
            var offerListTypicaHandlingRates = offer.offerList
                .typicaHandlingRates;
            result[key] =
                offerTypicaHandlingRates[key] || offerListTypicaHandlingRates[key];
            return result;
        }, {
            less_than_300kg: '',
            more_than_300kg: '',
            more_than_600kg: '',
            more_than_3000kg: '',
        });
    }, [offer]);
    return (React.createElement(Container, { maxWidth: "md", role: "main", "aria-label": "Transparency Information" },
        React.createElement(MainHeading, null, "Transparency Information"),
        React.createElement(LotTitle, null,
            offer.lotNumber,
            " ",
            offer.farm),
        React.createElement(Breakdown, { breakdown: breakdown, producerName: producerName, taxName: orderPriceItem.orderPrice.taxName, currency: orderPriceItem.orderPrice.currency, priceVersion: offer.offerList.priceVersion, vatReverseChargeEnabled: vatReverseChargeEnabled, isJpCalculation: orderPriceItem.orderPrice.isJpCalculation }),
        React.createElement(ExplanationRegion, { breakdown: breakdown, offerListStoryUrl: offer.offerList.storyUrls[i18n.language], typicaHandlingRates: typicaHandlingRates, producerName: producerName, orderPriceItem: orderPriceItem, vatReverseChargeEnabled: vatReverseChargeEnabled, exclusiveTypicaHandlingRate: orderPriceItem.orderItem.exclusiveTypicaHandlingRate })));
};
export default TransparencyInformation;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
